import BaseAPI from '@/apis/base/baseApi';

export default class CompareApi extends BaseAPI {
  apiName = 'Business';
}
